module.exports = __webpack_public_path__ + "static/media/badge_ptrnB.dd3ad5eb.png";